import { useState, useEffect, useRef, useContext, useCallback } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
// import { docco } from 'react-syntax-highlighter/dist/esm/styles/json';

import TableContext from '../tableContext/tableContext';
import ReactApiService from '../../services/reactApiService';

import './scrollDialog.css';

export default function ScrollDialog(props) {
	
	let tableContext = useContext(TableContext);
	// console.log(' tableContext.optionName ::', tableContext.optionName);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
	const scroll = 'paper';
	
	
  // const handleClose = (e, reason) => {
		// console.log('handleClose ::');
	// }
	
  const handleCloseClick = () => {
		tableContext.reset();
    setOpen(false);
  };

	// keep function reference.
  const getData = useCallback( () => {	
		// console.log('getData :: inside');
		const dataService = new ReactApiService();		
		dataService.get('getOption')
		.then( 
			(response) => {
				// console.log(' getOption response ::', response );
				setContent(response.message);
				/*
				this.setState({
					isLoaded: true,
					tableItems: response.data.map( item => {
						return {
							id: parseInt(item.id),
							ID: parseInt(item.id),
							mask: item.mask,
							editable: item.editable,
						}
					}) 
				});	
				// */
			},
			// Note: it's important to handle errors here
			// instead of a catch() block so that we don't swallow
			// exceptions from actual bugs in components.
			(error) => {
				/*
				this.setState({
					isLoaded: true,
					error
				});
				// */
			}
		).then(() => {
			return;
		})		
	}, []) 		

  useEffect(() => {
		// console.log('useEffect tableContext.optionName ::', tableContext.optionName);
    if ('string' === typeof tableContext.optionName) {
			setOpen(true)
    } else {
			setOpen(false)
		}
  }, [tableContext.optionName]);	

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
			// console.log('useEffect :: before getData');
			getData();
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
				console.log('descriptionElementRef ::', descriptionElementRef);
      }
    }
  }, [open,getData]);	
	
/*	
<TableContext.Consumer>
	{({optionName, resetOptionName}) => (
		// code
	)}
</TableContext.Consumer>
// */

				/*
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            {[...new Array(50)]
              .map(
                () => `Cras mattis consectetur purus sit amet fermentum.
Cras justo odio, dapibus ac facilisis in, egestas eget quam.
Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
Praesent commodo cursus magna, vel scelerisque nisl consectetur et.`,
              )
              .join('\n')}
          </DialogContentText>
					// */
        // onClose={handleClose}
	
  return (
    <>
			<Dialog
        open={open}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Option: {tableContext.optionName}</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
						<SyntaxHighlighter language="javascript" style={docco}>
							 {content}
						</SyntaxHighlighter>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseClick}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
